<template>
    <modal :show="showImportModal" @close="closeImportModal">
      <template v-slot:header>
        <h3>{{$t("import.translations.title")}}</h3>
      </template>
      <template>
          <!-- traduction -->
          <div class="login-form" v-if="!isLoadingImportModal">
            <span class="login-form-label">{{$t("import.translations.description")}}</span>
            <b-form-file 
              v-model="file" 
              class="mt-3"
              :browse-text="$t('import.translations.browse')"
              :placeholder="$t('import.translations.choose')"
              :drop-placeholder="$t('import.translations.drop')"
            >{{$t("import.translations.import")}}</b-form-file>

            <pre v-if="errorReport != ''" style="margin-top: .5em">{{errorReport}}</pre>
          </div>
          <div v-else class="text-center" style="width: 100%; margin-top: .5em;">
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
          </div>
      </template>
      <template v-slot:footer>
        <b-button variant="secondary" @click="closeImportModal">
          {{$t("import.cancel")}}
        </b-button>
        <b-button variant="primary" @click="validate">
          {{$t("import.validate")}}
        </b-button>
      </template>
    </modal>
</template>

<script lang="ts">
import { loadLanguageAsync } from "@/i18n";
import ImportService from '@/services/ImportService';
import { Component,Vue } from 'vue-property-decorator';


@Component({
  components: {
    Modal: () => import('@/components/Shared/Modal.vue')
  },
})
export default class ImportLoadingModal extends Vue {
  private file = null;
  public showImportModal: boolean = false;
  private isLoadingImportModal: Boolean = false;
  private errorReport: string = "";

  public openImportModal() {
    this.showImportModal = true;
  }

  public closeImportModal() {
    if(!this.isLoadingImportModal) this.showImportModal = false;
  }

  private async validate() {
    if(this.file !== undefined && this.file != null) {
      const formData = new FormData();
      this.errorReport = "";
      formData.append("File", this.file || "");

      this.isLoadingImportModal = true;

      try {
        const result = await ImportService.importTranslations(formData);
  
        this.isLoadingImportModal = false;
        if(result?.status == 200) {
  
          if(result.data != "Success") {
            this.errorReport = result.data;
          } else {
            this.closeImportModal();
            this.$notify({
              group: "global",
              type: "success",
              title: this.$t("import.successfull.title").toString(),
              text: this.$t("import.successfull.description").toString(),
            });
            await loadLanguageAsync(this.$i18n.locale, true);
            this.$emit('handleImportSuccess');
          }
  
        }
      } catch (error) {
        this.isLoadingImportModal = false;
        this.$notify({
          group: "global",
          type: "error",
          title: this.$t("import.error.title").toString(),
          text: this.$t("import.error.description").toString(),
        });
      }
      this.showImportModal = false;
    }
  }
}
</script>

<style scoped="scss">
</style>
